import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["icon"];
import React, { forwardRef } from 'react';
import EzIconMui from '../EzIconMui/EzIconMui';
var EzIconReactElement = forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    props = _objectWithoutProperties(_ref, _excluded);
  return React.createElement(EzIconMui, _extends({
    ref: ref
  }, props), icon);
});
EzIconReactElement.displayName = 'EzIconReactElement';
export default EzIconReactElement;